import { TextField } from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';

export function MaterialTypeForm({
  errors,
  materialType,
  Controller,
  control,
}) {
  return (
    <div className="flex flex-row flex-wrap">
      <div className="w-full px-1 py-2">
        <Controller
          name={'name'}
          control={control}
          defaultValue={materialType ? materialType.name : ''}
          rules={{ required: true }}
          render={({ field }) => (
            <TextField
              {...field}
              label="ชื่อประเภทสินค้า"
              required
              fullWidth
              size={'small'}
              helperText={errors.name && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
      <div className="w-full px-1 py-2">
        <Controller
          name={'vat'}
          control={control}
          defaultValue={materialType ? materialType.vat : ''}
          rules={{ required: true }}
          render={({ field }) => (
            <TextField
              {...field}
              label="%การคำนวณ"
              required
              fullWidth
              size={'small'}
              helperText={errors.vat && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
      <div className="w-full px-1 py-1">
        <Controller
          name={'description'}
          control={control}
          defaultValue={materialType ? materialType.description : ''}
          render={({ field }) => (
            <TextField
              {...field}
              label="รายละเอียด"
              fullWidth
              multiline
              rows={4}
              size={'small'}
              helperText={errors.descrtiption && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
    </div>
  );
}

MaterialTypeForm.propTypes = {
  materialType: PropTypes.object,
  errors: PropTypes.shape({
    name: PropTypes.object,
    vat: PropTypes.object,
    type_code: PropTypes.object,
    description: PropTypes.object,
  }),
  Controller: PropTypes.func,
  control: PropTypes.object,
};

MaterialTypeForm.defaultProps = {
  materialType: null,
};

export default MaterialTypeForm;
